import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";


const SocialLinks = () => {
  const links = [
    {
      id: 1,
      child: (
        <>
          LinkedIn
          <FaLinkedin size={25} />
        </>
      ),
      href: "https://www.linkedin.com/in/malhotrah/",
      style: "rounded-tr-md",
    },
    {
      id: 2,
      child: (
        <>
          Github
          <FaGithub size={25} />
        </>
      ),
      href: "https://github.com/malhotra-hitesh",
    },
    {
      id: 3,
      child: (
        <>
          Mail
          <HiOutlineMail size={25} />
        </>
      ),
      href: "mailto:hitesh.malhotra@bluewin.ch",
    },
  ];

  return (
    <div className="fixed top-[35%] left-0">
      <ul>
        {links.map(({ id, child, href, style, download }) => (
          <li
            key={id}
            className={
              "flex justify-between items-center w-36 h-14 px-3 ml-[-100px] hover:ml-[-10px] hover:rounded-md  transition-transform duration-300 bg-gray-500 text-sm md:w-40 md:text-base" +
              " " +
              style
            }
          >
            <a
              href={href}
              className="flex justify-between items-center w-full text-white"
              download={download}
              target="_blank"
              rel="noreferrer"
            >
              {child}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SocialLinks;
